//授课签到
export const SK_YXTASK_LIST = 'sk_yxtask_list'
//预习详情
export const SK_YXTASK_DETAILS = 'sk_yxtask_Details'
//预习测验详情
export const SK_YXTASK_LISTDETAIL = 'sk_yxtask_listDetail'
//学生疑惑留言
export const SK_YXTASK_STUROOTMESSAGE = 'sk_yxtask_StuRootMessage'



// WEBPACK FOOTER //
// ./src/store/give-course/yxTask/type.js